import { z } from 'zod'

export const AUTH_PASSWORD_LENGTH_ERROR = 'Panjang karakter antara 8-72.'
export const authPasswordSchema = z
  .string()
  .refine((value) => value.trim().length > 0, 'Password harus diisi.')
  .min(8, AUTH_PASSWORD_LENGTH_ERROR)
  .max(72, AUTH_PASSWORD_LENGTH_ERROR)

export const loginPhoneSchema = z
  .string()
  .trim()
  .min(1, 'Nomor Handphone wajib diisi.')
  .regex(/^[1-9][0-9]*$/, 'Format nomor handphone tidak sesuai.')
  .min(7, 'Panjang karakter antara 7-13.')
  .max(13, 'Panjang karakter antara 7-13.')

/** Keep each Nuxt flow's phone normalization separate from API E.164 formatting. */
export function normalizeAuthPhone(value: string, flow: 'login' | 'register' | 'reset') {
  const digits = value.replace(/\D/g, '')
  if (flow === 'login') return digits
  if (flow === 'reset') return digits.startsWith('62') ? digits.slice(2) : digits
  const local = digits.replace(/^(?:62|0)/, '')
  return local && !local.startsWith('8') ? '' : local
}
